import { getNested } from 'srcReact/helpers/validator'
import { isNative, urlSearchParams } from './utils'
import { getCurrentOrg } from 'srcReact/helpers/organizationHelper'

export const getRestriction = (workplace, user_type, retriction_type) => {
  return getNested(workplace, 'info', 'content_restriction', user_type, retriction_type)
}

export const getRestrictions = (workplace, user_type) => {
  return getNested(workplace, 'info', 'content_restriction', user_type)
}

export const canCreateGroups = (workplace, user_type) => {
  return getRestriction(workplace, user_type, 'can_create_groups')
}

export const canCreatePrivateGroups = (workplace, user_type) => {
  return getRestriction(workplace, user_type, 'can_create_private_groups')
}

export const canCreatePublicGroups = (workplace, user_type) => {
  return getRestriction(workplace, user_type, 'can_create_public_groups')
}

export const formatRestrictionsForUpdate = (workplace, user_type) => {
  switch (user_type) {
    case 'organization_member':
      return {
        'can-create-groups': canCreateGroups(workplace, user_type),
        'can-create-public-groups': canCreatePublicGroups(workplace, user_type),
        'can-create-private-groups': canCreatePrivateGroups(workplace, user_type)
      }
      break
    case 'alumni':
      return {
        'can-create-groups': canCreateGroups(workplace, user_type),
        'can-create-public-groups': canCreatePublicGroups(workplace, user_type),
        'can-create-private-groups': canCreatePrivateGroups(workplace, user_type)
      }
      break
    default:
      return {}
      break
  }
}

export const reformatRestrictions = (obj) => {
  const newObj = {}
  Object.keys(obj).map((key, indx) => {
    newObj[key.replace(/-/g, '_')] = obj[key]
  })
  return newObj
}

export const isWorkplaceManager = () => {
  const currentOrganization = getCurrentOrg()
  if (
    getNested(currentOrganization, 'info', 'my_access', 'role_as_workplace_manager') ||
    getNested(currentOrganization, 'my_access', 'role_as_workplace_manager') ||
    getNested(currentOrganization, 'organizations_my_access', 'role_as_workplace_manager')
  ) {
    return true
  }
  return false
}

export const getWorkplaceIds = (currentOrg) => {
  // if (isNative()) {
  //   workplaceIds = urlSearchParams('id_workplace')
  //   return workplaceIds?.toString()
  // }
  const workplaceIds = currentOrg?.info?.my_access?.role_as_workplace_member?.workplace_list?.toString()
  return workplaceIds
}
